import api from "@/api/api";
import { getTagList } from "@/api/tag";
import { EVENT_TYPES } from "@/views/MultiDimen/components/constants";

export default {
  namespaced: true,
  state: {
    // 拨片数据
    pickList: [],
    // 鼓机分类数据
    drumCategories: [],
    // 数据加载状态
    dataLoaded: {
      pick: false,
      drum: false,
    },

    pageConfig: {
      pageSize: 1000,
      pageNum: 1,
    },

    // 歌曲元数据标签
    songMetadataTags: {},
  },
  mutations: {
    SET_PICK_LIST(state, list) {
      state.pickList = list;
      state.dataLoaded.pick = true;
    },
    SET_DRUM_CATEGORIES(state, categories) {
      state.drumCategories = categories;
      state.dataLoaded.drum = true;
    },
  },
  actions: {
    // 获取
    async getSongMetadataTags({ state, commit }) {
      try {
        const res = await getTagList();
        if (res?.data?.code === 1) {
          const tagData = res.data.data;
          let result = {};
          if (tagData) {
            // state.songMetadataTags = tagData;
            for (const key in tagData) {
              let element = tagData[key];
              const idEmpty = element.children.some(
                (item) => item.label === "无" || item.label === "无标签"
              );
              if (!idEmpty) {
                element.children.push({
                  id: 0,
                  label: "无",
                  parentId: 0,
                  children: null,
                });
              }
              element.children = element.children;
              result[key] = element;
            }
            state.songMetadataTags = result;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    // 获取拨片列表
    async fetchPickList({ state, commit }) {
      if (state.dataLoaded.pick) return;
      try {
        const resp = await api.PICK_SEARCH({
          ...state.pageConfig,
        });
        commit("SET_PICK_LIST", resp.data.data?.list ?? []);
        console.log(resp.data.data?.list, "state");
      } catch (error) {
        console.error("获取拨片列表失败:", error);
      }
    },
    // 获取鼓机分类
    async fetchDrumCategories({ state, commit }) {
      if (state.dataLoaded.drum) return;
      try {
        const res = await api.DRUM_SEARCH({
          ...state.pageConfig,
        });
        commit("SET_DRUM_CATEGORIES", res.data.data?.list ?? []);
      } catch (error) {
        console.error("获取鼓机分类失败:", error);
      }
    },

    // 检查鼓机事件配置
    checkDrumEvents({ commit }, privateRows) {
      try {
        // 检查私有轨中的鼓机事件和情绪鼓机事件
        let lastDrumEvent = null;
        let lastDrumEventCellIndex = -1;
        let lastU1DrumEvent = null;
        let lastU1DrumEventCellIndex = -1;

        if (privateRows) {
          for (const row of privateRows) {
            // 检查是否是鼓机类型的轨道
            if (row.type === EVENT_TYPES.DRUM) {
              // DRUM 类型
              // 遍历该行的所有单元格
              for (let i = 0; i < row.cells.length; i++) {
                const cell = row.cells[i];
                // 检查单元格是否有活动事件
                if (cell.active && cell.event) {
                  lastDrumEvent = cell.event;
                  lastDrumEventCellIndex = i;
                }
              }
            }
            // 检查是否是情绪鼓机类型的轨道
            if (row.type === EVENT_TYPES.U1_DRUM) {
              // U1_DRUM 类型
              // 遍历该行的所有单元格
              for (let i = 0; i < row.cells.length; i++) {
                const cell = row.cells[i];
                // 检查单元格是否有活动事件
                if (cell.active && cell.event) {
                  lastU1DrumEvent = cell.event;
                  lastU1DrumEventCellIndex = i;
                }
              }
            }
          }
        }

        // 检查结果
        const drumHasOpen = lastDrumEvent !== null;
        const drumHasClose = drumHasOpen && lastDrumEvent.switchType === 0;
        const u1DrumHasOpen = lastU1DrumEvent !== null;
        const u1DrumHasClose = u1DrumHasOpen && lastU1DrumEvent.switchType === 0;

        // 构建错误信息
        const errorMessages = [];
        if (drumHasOpen && !drumHasClose) {
          errorMessages.push("鼓机");
        }
        if (u1DrumHasOpen && !u1DrumHasClose) {
          errorMessages.push("情绪鼓机");
        }

        // 如果有错误
        if (errorMessages.length > 0) {
          return {
            success: false,
            message: `${errorMessages.join("和")}没有配置关鼓机，请检查`,
          };
        }

        // 没有鼓机事件或最后一个是关鼓事件
        return {
          success: true,
          message: "鼓机事件配置正确",
        };
      } catch (error) {
        console.error("检查鼓机事件失败:", error);
        return {
          success: false,
          message: "检查鼓机事件时发生错误",
        };
      }
    },
  },
  getters: {
    pickList: (state) => state.pickList,
    drumCategories: (state) => state.drumCategories,
    // 根据code获取拨片名称
    getPickNameByCode: (state) => (code) => {
      const pick = state.pickList.find((item) => item.code === code);
      return pick ? pick.name : "未知拨片";
    },
    // 根据code获取鼓机名称
    getDrumNameByCode: (state) => (code) => {
      const drum = state.drumCategories.find((item) => item.code === code);
      return drum ? drum.name : "未知鼓机";
    },
  },
};
